/* ============================================
   MENÚ HOVER COSEMANIA - VERSIÓN COMPLETA
   Desktop: Hover automático
   Mobile: Botón atrás visible
   ============================================ */

// ========== MENÚ DESKTOP ==========
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHoverMenu);
} else {
  initHoverMenu();
}

function initHoverMenu() {
  // Solo en desktop
  if (window.innerWidth < 990) return;
  
  const headerMenus = document.querySelectorAll('header-menu');
  
  headerMenus.forEach(menu => {
    const details = menu.querySelector('details');
    const summary = menu.querySelector('summary');
    
    if (!details || !summary) return;
    
    let closeTimeout;
    
    // ABRIR al pasar el cursor
    menu.addEventListener('mouseenter', function() {
      clearTimeout(closeTimeout);
      if (window.innerWidth >= 990) {
        details.setAttribute('open', '');
      }
    });
    
    // CERRAR al salir (con pequeño delay)
    menu.addEventListener('mouseleave', function() {
      if (window.innerWidth >= 990) {
        closeTimeout = setTimeout(() => {
          details.removeAttribute('open');
        }, 150);
      }
    });
    
    // PREVENIR clic en desktop
    summary.addEventListener('click', function(e) {
      if (window.innerWidth >= 990) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    });
    
    // PREVENIR que el navegador cierre el details
    details.addEventListener('toggle', function(e) {
      if (window.innerWidth >= 990 && menu.matches(':hover')) {
        if (!details.hasAttribute('open')) {
          details.setAttribute('open', '');
        }
      }
    });
  });
}

// Re-inicializar al cambiar tamaño de ventana
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(initHoverMenu, 250);
});

// ========== BOTÓN ATRÁS MÓVIL ==========
document.addEventListener('DOMContentLoaded', function() {
  
  // Solo en móvil
  if (window.innerWidth >= 990) return;
  
  // Función para añadir botón atrás
  function addBackButtons() {
    const menuDrawer = document.querySelector('.menu-drawer');
    if (!menuDrawer) return;
    
    const detailsElements = menuDrawer.querySelectorAll('details[role="list"]');
    
    detailsElements.forEach(function(details) {
      const submenu = details.querySelector('.header__submenu, ul');
      if (!submenu) return;
      
      // Verificar si ya existe el botón
      if (submenu.querySelector('.back-button-mobile')) return;
      
      // Crear botón atrás
      const backButton = document.createElement('li');
      backButton.className = 'back-button-mobile';
      backButton.innerHTML = `
        <button type="button" class="back-btn">
          <span class="back-arrow">←</span>
          <span class="back-text">Volver al menú</span>
        </button>
      `;
      
      // Insertar al principio del submenú
      submenu.insertBefore(backButton, submenu.firstChild);
      
      // Evento click para cerrar
      const btn = backButton.querySelector('.back-btn');
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        details.removeAttribute('open');
      });
    });
  }
  
  // Ejecutar
  addBackButtons();
  
  // Re-ejecutar si se añaden elementos dinámicamente
  const observer = new MutationObserver(addBackButtons);
  const menuDrawer = document.querySelector('.menu-drawer');
  if (menuDrawer) {
    observer.observe(menuDrawer, { childList: true, subtree: true });
  }
});

